/**
 * Generated by tooling/scripts/extract-state-classes.mjs from GUI_Design/design/01 Token System v2.dc.html.
 * Do not edit by hand: the design file is the approved source and these values are read from it.
 *
 * A state is never shown by colour alone. Every badge pairs a glyph with a word, so the same
 * information reaches a reader who cannot tell the two greens apart and a reader looking at a
 * monochrome print of a board.
 */
export const stateClasses = [
    {
        key: "human",
        label: "Needs a human",
        hue: "attention",
        glyph: "diamond",
        solid: true,
        sort: 1,
        examples: "action_required · delivery_attempted · open",
        rationale: "Solid and sorted first: states that need a person get the most weight.",
    },
    {
        key: "failed",
        label: "Failed",
        hue: "danger",
        glyph: "octagon",
        solid: true,
        sort: 2,
        examples: "failed · rejected · no_show",
        rationale: "Terminal failure is a peer of success. Solid, second in sort.",
    },
    {
        key: "unknown",
        label: "Not confirmed",
        hue: "neutral",
        glyph: "unknown",
        solid: false,
        sort: 3,
        examples: "pending_confirmation · outcome_unknown · pending sync",
        rationale: "Dashed and grey: borrows neither success nor failure, because neither is true yet.",
    },
    {
        key: "caution",
        label: "Qualified",
        hue: "warning",
        glyph: "triangle",
        solid: false,
        sort: 4,
        examples: "conditionally_approved · partially_completed · retry_scheduled",
        rationale: "An outcome with a condition attached. Readable, not alarming.",
    },
    {
        key: "active",
        label: "In progress",
        hue: "info",
        glyph: "half",
        solid: false,
        sort: 5,
        examples: "driver_en_route · in_trip · in_custody · offering",
        rationale: "Moving, not finished.",
    },
    {
        key: "waiting",
        label: "Waiting on others",
        hue: "neutral",
        glyph: "ringdot",
        solid: false,
        sort: 6,
        examples: "submitted · in_review · verification_pending · viewed",
        rationale: "Another party holds it.",
    },
    {
        key: "idle",
        label: "Not started",
        hue: "neutral",
        glyph: "ring",
        solid: false,
        sort: 7,
        examples: "draft · created · assigned · queued",
        rationale: "Exists; nothing has happened yet.",
    },
    {
        key: "done",
        label: "Succeeded",
        hue: "success",
        glyph: "dot",
        solid: false,
        sort: 8,
        examples: "completed · delivered · approved · resolved",
        rationale: "Low in sort: finished work needs no attention.",
    },
    {
        key: "closed",
        label: "Closed",
        hue: "neutral",
        glyph: "square",
        solid: false,
        sort: 9,
        examples: "cancelled · withdrawn · expired · archived · merged",
        rationale: "Ended without success or failure.",
    },
];
const byKey = new Map(stateClasses.map((entry) => [entry.key, entry]));
export function stateClass(key) {
    const found = byKey.get(key);
    if (found === undefined) {
        throw new Error(`No state class named ${key}`);
    }
    return found;
}
export const lifecycles = [
    {
        subject: "trip",
        code: "TRP-01",
        statuses: {
            assigned: "idle",
            driver_en_route: "active",
            driver_arrived: "active",
            waiting: "active",
            in_trip: "active",
            completed: "done",
            cancelled: "closed",
            no_show: "failed",
        },
    },
    {
        subject: "delivery-order",
        code: "DEL-03",
        statuses: {
            accepted: "idle",
            pickup_ready: "waiting",
            in_custody: "active",
            delivery_attempted: "human",
            delivered: "done",
            cancelled: "closed",
            failed: "failed",
        },
    },
    {
        subject: "delivery-exception",
        code: "DEL-08",
        statuses: {
            open: "human",
            retry_scheduled: "caution",
            return_to_origin: "caution",
            resolved: "done",
            cancelled: "closed",
        },
    },
    {
        subject: "ride-offer",
        code: "DSP-02",
        statuses: {
            created: "idle",
            delivered: "waiting",
            viewed: "waiting",
            accepted: "done",
            rejected: "closed",
            expired: "closed",
            cancelled: "closed",
        },
    },
    {
        subject: "dispatch saga",
        code: "DSP-04",
        statuses: {
            finding_candidates: "active",
            offering: "active",
            assigning: "active",
            completed: "done",
            failed: "failed",
        },
    },
    {
        subject: "merchant acceptance",
        code: "COM-06",
        statuses: {
            pending: "waiting",
            accepted: "done",
            rejected: "closed",
            expired: "closed",
        },
    },
    {
        subject: "fulfillment coordination",
        code: "COM-08",
        statuses: {
            pending: "idle",
            requesting: "active",
            delivery_created: "done",
            outcome_unknown: "unknown",
            failed: "failed",
        },
    },
    {
        subject: "merchant",
        code: "MER-01",
        statuses: {
            pending_review: "waiting",
            active: "done",
            suspended: "caution",
            closed: "closed",
        },
    },
    {
        subject: "driver-onboarding",
        code: "DRV-02",
        statuses: {
            draft: "idle",
            submitted: "waiting",
            in_review: "waiting",
            action_required: "human",
            verification_pending: "waiting",
            decision_pending: "waiting",
            approved: "done",
            conditionally_approved: "caution",
            rejected: "failed",
            withdrawn: "closed",
        },
    },
    {
        subject: "mobile sync",
        code: "Doc 16 §8",
        statuses: {
            submitted: "unknown",
            pending_sync: "unknown",
            confirmed: "done",
            rejected_after_sync: "failed",
        },
    },
];
/**
 * The class a status belongs to, or `undefined` when nothing has said.
 *
 * Deliberately returns `undefined` rather than falling back to a neutral class. A status with no
 * mapping is a screen about to render a state nobody has decided how to show, and that is worth
 * seeing as a gap rather than as a grey badge. 68 services publish a status enum this table does not
 * cover; see docs/design/DESIGN_RECONCILIATION.md.
 *
 * The lookup is exact. Four services publish upper-case status values where 73 publish lower-case,
 * and normalising here would also accept a status no contract publishes — a screen would then show a
 * plausible badge for a value the platform can never send.
 */
export function classOfStatus(code, status) {
    return lifecycles.find((lifecycle) => lifecycle.code === code)?.statuses[status];
}
//# sourceMappingURL=state-classes.js.map